import { render, staticRenderFns } from "./ConfigPC.vue?vue&type=template&id=8c7b4b72&scoped=true&"
import script from "./ConfigPC.vue?vue&type=script&lang=js&"
export * from "./ConfigPC.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPC.vue?vue&type=style&index=0&id=8c7b4b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7b4b72",
  null
  
)

export default component.exports